/* eslint-disable import/no-cycle */
// Utils
import { removeValuesRecursive } from './removeValuesRecursive';
/**
 * Remove all of the defined values from the given array and nested objects/arrays.
 *
 * @param {any} arrayValues
 * @param {any[]} toRemove
 *
 * @return {any}
 */
export var removeValuesForArrayRecursive = function (arrayValues, toRemove) {
    var hasChange = false;
    var newArray = [];
    arrayValues.forEach(function (value) {
        var newValue = removeValuesRecursive(value, toRemove);
        if (newValue !== value) {
            hasChange = true;
            if (newValue === undefined) {
                return;
            }
        }
        newArray.push(newValue);
    });
    return hasChange ? newArray : arrayValues;
};
//# sourceMappingURL=removeValuesForArrayRecursive.js.map